import {areDiscoverySettingsEqual, Home, VerificationStatusDTO} from '@/domain';
import {appStore} from '@/entities/app';
import {boostStore} from '@/entities/boost';
import {resetBoosts} from '@/entities/boost/lib/resetBoosts';
import {discoveryStore} from '@/entities/discovery';
import {resetUsers} from '@/entities/discovery/lib/resetUsers';
import {geoStore} from '@/entities/geo';
import {notificationStore} from '@/entities/notification';
import {settingsStore} from '@/entities/settings';
import {userStore} from '@/entities/user';
import {handleLogout} from '@/utils_legacy/auth';

import {WorkerActions} from '../workerActions';

const handledActions = [
  WorkerActions.GetData,
  WorkerActions.SocketMessage,
  WorkerActions.Banned,
];

enum SocketMessageTypes {
  Me = 'me',
  MeSubscription = 'me.subscription',
  MeSubscriptionSuperSmashes = 'me.subscription.super_smashes',
  MeBalance = 'me.balance',
}

export const handleUserDataEvent = async (event: MessageEvent) => {
  const {action, data, dataKey} = event.data;

  if (!handledActions.includes(action)) {
    return;
  }
  if (action === WorkerActions.GetData) {
    switch (dataKey) {
      case 'userData': {
        const home: Home = data;
        appStore.replaceUserAbTests(home.abtests);
        userStore.setUserData(home.me.user);
        userStore.setHomeData(home);
        boostStore.setMyBoost(home.boost);
        geoStore.addCities(home.cities);
        geoStore.addCountries(home.countries);
        settingsStore.setSettings(home.me.settings);
        discoveryStore.setUserUndoInfo(home.me.subscription.undo_info);
        break;
      }
    }
    return;
  }

  if (action === WorkerActions.SocketMessage) {
    switch (data.res) {
      case SocketMessageTypes.Me: {
        switch (data.action) {
          case 'verified': {
            const {status} = data.model as VerificationStatusDTO;
            userStore.setVerified(data.model.status === 'DONE');
            settingsStore.patchSettings({
              verification_status: data.model.status,
            });
            if (status === 'DONE' || status === 'ERROR') {
              notificationStore.addVerificationNotification({status});
            }
            break;
          }
          case 'changed': {
            const sameSettings = areDiscoverySettingsEqual(
              settingsStore.current,
              data.model.settings
            );
            if (!sameSettings) {
              settingsStore.setSettings(data.model.settings);
              resetUsers();
              resetBoosts();
            }
            userStore.setMe(data.model);
            break;
          }
          case 'moderated': {
            userStore.setMe(data.model);
            break;
          }
          case 'confirmed': {
            settingsStore.patchSettings({
              unconfirmed: undefined,
            });
            break;
          }
        }
        break;
      }
      case SocketMessageTypes.MeSubscription:
        if (data.action === 'changed') {
          userStore.setSubscriptionData(data.model);
        }
        break;
      case 'unreads': {
        if (userStore.home) {
          userStore.setUnreads(data.model);
        }
        break;
      }
      case 'reaction.total_count':
        userStore.setTotalReactions(data.model.value);
        break;
      case SocketMessageTypes.MeBalance:
        if (data.action === 'changed') {
          userStore.setBalance(data.model);
        }
        break;
      case SocketMessageTypes.MeSubscriptionSuperSmashes:
        if (data.action === 'bonus') {
          userStore.setBalance(data.model);
        }
    }

    return;
  }

  if (action === WorkerActions.Banned) {
    handleLogout(data.model.id, data.model.user_id, data.model.until);
    return;
  }
};
